import { Direction } from './types';

export const DIRECTIONS: Direction[] = [
  [1, 0],  // vertical
  [0, 1],  // horizontal
  [1, 1],  // diagonal \
  [1, -1], // diagonal /
];

export function directionToString(direction: Direction): string {
  if (direction.at(0) === 1 && direction.at(1) === 0) {
    return "vertical";
  } else if (direction.at(0) === 0 && direction.at(1) === 1) {
    return "horizontal";
  } else if (direction.at(0) === 1 && direction.at(1) === 1) {
    return "diagonal\\";
  } else if (direction.at(0) === 1 && direction.at(1) === -1) {
    return "diagonal\\";
  } else {
    throw Error("Given direction isn't valid");
  }
}